import { tensorflow } from './proto';
var NoteSequence = tensorflow.magenta.NoteSequence;
export { NoteSequence };
//# sourceMappingURL=index.js.map